import { render, staticRenderFns } from "./QuizInstanceCard.vue?vue&type=template&id=2770777c&scoped=true&"
import script from "./QuizInstanceCard.vue?vue&type=script&lang=ts&"
export * from "./QuizInstanceCard.vue?vue&type=script&lang=ts&"
import style0 from "./QuizInstanceCard.vue?vue&type=style&index=0&id=2770777c&scoped=true&lang=scss&"
import style1 from "./QuizInstanceCard.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2770777c",
  null
  
)

export default component.exports